import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Globals from '../Globals';
import StyledTemplateFullPage from './StyledTemplateFullPage';

const TemplateFullPage = ({children, includeScroll, isFlex = true}) => {
	const renderContent = () => {
		if (includeScroll) return <div className="customScrollbar">{children}</div>;
		return children;
	};

	const props = {
		className: classNames({flex: isFlex})
	};

	return (
		<StyledTemplateFullPage {...props}>
			<Globals />
			{renderContent()}
		</StyledTemplateFullPage>
	);
};

TemplateFullPage.propTypes = {
	includeScroll: PropTypes.bool
};

TemplateFullPage.defaultProps = {
	includeScroll: true
};

export default TemplateFullPage;
